var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered"},[_c('Title',[_vm._v(" 家庭签约医生 ")]),_c('LabelValueGrid',{staticClass:"desc",attrs:{"data":_vm.dataByLevel}}),_c('BaseEchart',{staticStyle:{"width":"100%","height":"303px"},attrs:{"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }